import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Statistics } from "@app/core/statistics/domain/model/statistics";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Injectable } from "@angular/core";
import { StatisticsMapper } from "@app/core/statistics/data/network/mapper/statistics.mapper";
import { EvolutionaryMapper } from "./mapper/evolutionary.mapper";

/**
 * Web service to get the general statistics of the user.
 */
@Injectable({
  providedIn: "root",
})
export class ListStatisticsWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(limit: number, token: string): Observable<Statistics> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.get)
      .setUrl(ApiUrls.LIST_STATISTICS_ENDPOINT())
      .setAuthorization(new TokenAuthorization(token))
      .setUrlParams({ limit })
      .build();

    return this.baseHandler
      .execute(parameters)
      .pipe(map((response) => EvolutionaryMapper.deserialize(response)));
  }
}
